export default function TextArea({ value, onChange, label, placeholder, rows = 3 }) {
  const displayValue =
    value && typeof value === "object" ? JSON.stringify(value, null, 2) : value || "";
  return (
    <textarea
      className="lfx-input lfx-textarea"
      value={displayValue}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || label || ""}
      rows={rows}
    />
  );
}
